export default function () {
  return {
    success: null,
    loading: false,
  }
}
